var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07031 1.42188C6.35156 0.859375 7.14844 0.882812 7.40625 1.42188L8.95312 4.53906L12.375 5.03125C12.9844 5.125 13.2188 5.875 12.7734 6.32031L10.3125 8.73438L10.8984 12.1328C10.9922 12.7422 10.3359 13.2109 9.79688 12.9297L6.75 11.3125L3.67969 12.9297C3.14062 13.2109 2.48438 12.7422 2.57812 12.1328L3.16406 8.73438L0.703125 6.32031C0.257812 5.875 0.492188 5.125 1.10156 5.03125L4.54688 4.53906L6.07031 1.42188Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8ff1decbf33ce71a8cdc94fec464bf3e.svg";
export { ForwardRef as ReactComponent };